module.exports = __webpack_public_path__ + "img/logo-footer.717db46b.png";